import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "purchase-online-oripa-modal" }
const _hoisted_2 = { class: "purchase-online-oripa-modal__title" }
const _hoisted_3 = { class: "purchase-online-oripa-modal__total-price-area" }
const _hoisted_4 = { class: "purchase-online-oripa-modal__amount" }
const _hoisted_5 = { class: "purchase-online-oripa-modal__total-price" }
const _hoisted_6 = { class: "credit-card-form" }
const _hoisted_7 = { class: "credit-card-form__top" }
const _hoisted_8 = { class: "credit-card-form__center-box" }
const _hoisted_9 = {
  key: 0,
  class: "credit-card-form__active-credit-card"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "credit-card-form__active-credit-card-no" }
const _hoisted_12 = {
  key: 1,
  class: "credit-card-form__credit-card-logos"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "credit-card-form__expire"
}
const _hoisted_19 = {
  key: 1,
  class: "credit-card-form__attention"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "form__group form__group--column" }
const _hoisted_22 = { class: "form__control" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "form__group" }
const _hoisted_25 = { class: "form__control" }
const _hoisted_26 = { class: "form__checkbox-label" }
const _hoisted_27 = { class: "form__checkbox-label" }
const _hoisted_28 = { class: "purchase-online-oripa-modal__purchase-button-wrapper" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.oripaUnit) + "口購入", 1),
      _createElementVNode("p", _hoisted_5, " ¥" + _toDisplayString(_ctx.totalPrice.toLocaleString()), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "credit-card-form__title" }, "クレジットカード", -1)),
          (_ctx.credit_card_registered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/images/icon_checked-circle-filled-green.svg" }, null, -1)),
                _createElementVNode("img", {
                  class: "credit-card-form__active-credit-card-image",
                  src: _ctx.activeCreditCardUrl
                }, null, 8, _hoisted_10),
                _createElementVNode("p", _hoisted_11, _toDisplayString(`************${_ctx.credit_card_no}`), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/images/icon_checked-circle-filled.svg" }, null, -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "credit-card-form__credit-card-logo",
                    src: _ctx.visaImageUrl
                  }, null, 8, _hoisted_13),
                  _createElementVNode("img", {
                    class: "credit-card-form__credit-card-logo",
                    src: _ctx.masterImageUrl
                  }, null, 8, _hoisted_14),
                  _createElementVNode("img", {
                    class: "credit-card-form__credit-card-logo",
                    src: _ctx.jcbImageUrl
                  }, null, 8, _hoisted_15),
                  _createElementVNode("img", {
                    class: "credit-card-form__credit-card-logo",
                    src: _ctx.amexImageUrl
                  }, null, 8, _hoisted_16),
                  _createElementVNode("img", {
                    class: "credit-card-form__credit-card-logo",
                    src: _ctx.dinersImageUrl
                  }, null, 8, _hoisted_17),
                  _cache[6] || (_cache[6] = _createTextVNode(" 未登録 ")),
                  (_ctx.credit_card_registered)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.credit_card_expire), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_19, " カードを登録してください。 "))
                ])
              ]))
        ]),
        _createElementVNode("a", {
          class: "credit-card-form__arrow-right-icon-wrapper",
          href: `/mypage/credit_card/edit?lottery_id=${_ctx.lottery_id}`
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("i", { class: "jirafficon jirafficon-arrow-right inline-icon" }, null, -1)
        ]), 8, _hoisted_20)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["form", _ctx.$style.payPoints])
    }, [
      _createElementVNode("div", _hoisted_21, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "form__label" }, "利用ポイント", -1)),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payPoints) = $event)),
            class: "form__input",
            type: "number",
            placeholder: "入力してください",
            name: "lottery_result[pay_points]",
            disabled: _ctx.allPoints,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateBillingAmountHandler && _ctx.updateBillingAmountHandler(...args)))
          }, null, 40, _hoisted_23), [
            [_vModelText, _ctx.payPoints]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, " 利用可能ポイント: " + _toDisplayString(_ctx.points.toLocaleString()) + "ポイント ", 1),
          _createElementVNode("label", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.allPoints) = $event)),
              type: "checkbox",
              class: "form__checkbox",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeAllCheckHandler && _ctx.changeAllCheckHandler(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.allPoints]
            ]),
            _cache[11] || (_cache[11] = _createTextVNode(" 利用可能ポイントをすべて使う "))
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.formappamount)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.list)
      }, [
        _createElementVNode("b", {
          class: _normalizeClass(_ctx.$style.b)
        }, _toDisplayString(_ctx.estimates.subject.label), 3),
        _createElementVNode("b", {
          class: _normalizeClass(_ctx.$style.b)
        }, _toDisplayString(_ctx.estimates.subject.value), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.list1)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimates.details, (detail) => {
          return (_openBlock(), _createElementBlock("div", {
            key: detail.label,
            class: _normalizeClass(_ctx.$style.parent)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.div)
            }, _toDisplayString(detail.label), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.div)
            }, _toDisplayString(detail.value), 3)
          ], 2))
        }), 128))
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("button", {
        class: _normalizeClass([
          'purchase-online-oripa-modal__purchase-button btn',
          _ctx.canPurchase ? 'btn--primary' : 'btn--disabled',
        ]),
        disabled: !_ctx.canPurchase,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.purchaseOnlineOripa()))
      }, " 購入する ", 10, _hoisted_29)
    ])
  ]))
}